"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.getConnetType = exports.formatData = exports.formatDataNoSlice = exports.showToast = exports.getLoginData = exports.getQQPkgVersion = exports.getWxPkgVersion = exports.getAndroidDeviceInfo = exports.getLastAds = exports.getQQBrowserVerCode = exports.getBrowserVersion = void 0;
const logger_1 = require("./logger");
const getLocal = (name) => {
    try {
        const obj = window.localStorage[name];
        return obj ? JSON.parse(obj) : null;
    }
    catch (err) {
        return null;
    }
};
const getLastAds = () => {
    const localData = getLocal('last_ads');
    if (!localData) {
        return '';
    }
    if (Date.parse(localData.expires) <= Date.parse(new Date().toString())) {
        return '';
    }
    return localData.data;
};
exports.getLastAds = getLastAds;
const deviceInfo = { androidId: '', macAddr: '', taid: '', oaid: '', imei: '' };
const getAndroidID = () => {
    var _b, _c, _d, _e;
    const getAndroidID = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.device) === null || _c === void 0 ? void 0 : _c.getAndroidID;
    const platForm = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.env) === null || _e === void 0 ? void 0 : _e.platForm;
    if (platForm === 'ADR' && getAndroidID) {
        if (deviceInfo.androidId !== '') {
            return Promise.resolve(deviceInfo.androidId);
        }
        return new Promise((resolve) => {
            getAndroidID((result) => {
                deviceInfo.androidId = result.androidID;
                resolve(result.androidID);
            }, (err) => {
                resolve('');
                (0, logger_1.logInfo)('GETANDROIDID_FUNCTION_CALL_FAIL', JSON.stringify(err));
                showToast('GETANDROIDID_FUNCTION_CALL_FAIL');
            });
        });
    }
    return Promise.resolve('');
};
const getMacAddr = () => {
    var _b, _c, _d, _e;
    const getMacAddress = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.device) === null || _c === void 0 ? void 0 : _c.getMacAddress;
    const platForm = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.env) === null || _e === void 0 ? void 0 : _e.platForm;
    if (platForm === 'ADR' && getMacAddress) {
        if (deviceInfo.macAddr !== '') {
            return Promise.resolve(deviceInfo.macAddr);
        }
        return new Promise((resolve) => {
            getMacAddress((result) => {
                deviceInfo.macAddr = result.mac;
                resolve(result.mac);
            });
        });
    }
    return Promise.resolve('');
};
const getOaid = () => {
    var _b, _c, _d, _e;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    const getOAID = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.device) === null || _e === void 0 ? void 0 : _e.getOAID;
    let exceptionHandler;
    const exceptionPromise = new Promise((resolve) => {
        exceptionHandler = setTimeout(() => {
            resolve('');
        }, 1500);
    });
    let oaidPromise;
    if (platForm === 'ADR' && getOAID) {
        if (deviceInfo.oaid !== '') {
            clearTimeout(exceptionHandler);
            oaidPromise = Promise.resolve(deviceInfo.oaid);
        }
        const isBaipai = isBaipaiBrowser();
        if (isBaipai) {
            oaidPromise = getBaipaiVerCode().then((verCode) => {
                if (Number(verCode) >= 50100410) {
                    return new Promise((resolve) => {
                        getOAID((oaid) => {
                            clearTimeout(exceptionHandler);
                            deviceInfo.oaid = oaid;
                            resolve(oaid);
                        });
                    });
                }
                clearTimeout(exceptionHandler);
                oaidPromise = Promise.resolve('');
            });
        }
        else if (getQQBrowserVerCode(2) >= 98) {
            oaidPromise = new Promise((resolve) => {
                getOAID((oaid) => {
                    clearTimeout(exceptionHandler);
                    deviceInfo.oaid = oaid;
                    resolve(oaid);
                });
            });
        }
        else {
            clearTimeout(exceptionHandler);
            oaidPromise = Promise.resolve('');
        }
    }
    else {
        clearTimeout(exceptionHandler);
        oaidPromise = Promise.resolve('');
    }
    return Promise.race([exceptionPromise, oaidPromise]);
};
const getTaid = () => {
    var _b, _c, _d, _e;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    const getTAID = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.device) === null || _e === void 0 ? void 0 : _e.getTAID;
    let exceptionHandler;
    const exceptionPromise = new Promise((resolve) => {
        exceptionHandler = setTimeout(() => {
            resolve('');
        }, 1500);
    });
    let taidPromise;
    if (platForm === 'ADR' && getTAID) {
        if (deviceInfo.taid !== '') {
            clearTimeout(exceptionHandler);
            taidPromise = Promise.resolve(deviceInfo.taid);
        }
        const isBaipai = isBaipaiBrowser();
        if (isBaipai) {
            taidPromise = getBaipaiVerCode().then((verCode) => {
                if (Number(verCode) >= 50100410) {
                    return new Promise((resolve) => {
                        getTAID((taid) => {
                            clearTimeout(exceptionHandler);
                            deviceInfo.taid = taid;
                            resolve(taid);
                        });
                    });
                }
                clearTimeout(exceptionHandler);
                taidPromise = Promise.resolve('');
            });
        }
        else if (getQQBrowserVerCode(2) >= 98) {
            taidPromise = new Promise((resolve) => {
                getTAID((taid) => {
                    clearTimeout(exceptionHandler);
                    deviceInfo.taid = taid;
                    resolve(taid);
                });
            });
        }
        else {
            clearTimeout(exceptionHandler);
            taidPromise = Promise.resolve('');
        }
    }
    else {
        clearTimeout(exceptionHandler);
        taidPromise = Promise.resolve('');
    }
    return Promise.race([exceptionPromise, taidPromise]);
};
const getImei = () => {
    var _b, _c, _d, _e;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    if (platForm !== 'ADR') {
        return Promise.resolve('');
    }
    if (isBaipaiBrowser()) {
        return Promise.resolve('');
    }
    if (getQQBrowserVerCode(3) < 1050) {
        return Promise.resolve('');
    }
    if (deviceInfo.imei) {
        return Promise.resolve(deviceInfo.imei);
    }
    const getIMEI = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.device) === null || _e === void 0 ? void 0 : _e.getIMEI;
    if (!getIMEI) {
        return Promise.resolve('');
    }
    const imeiPromise = new Promise((resolve) => {
        getIMEI((res) => {
            deviceInfo.imei = (res === null || res === void 0 ? void 0 : res.imei) || '';
            resolve(deviceInfo.imei);
        });
    });
    const exceptionPromise = new Promise((resolve) => {
        setTimeout(() => {
            resolve('');
        }, 1500);
    });
    return Promise.race([exceptionPromise, imeiPromise]);
};
const getAndroidDeviceInfo = () => {
    var _b, _c;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    if (platForm === 'ADR') {
        let exceptionHandler;
        const exceptionPromise = new Promise((resolve) => {
            exceptionHandler = setTimeout(() => {
                resolve({});
            }, 2000);
        });
        let promiseArr;
        if (isBaipaiBrowser()) {
            promiseArr = [getAndroidID(), getMacAddr()];
        }
        else {
            promiseArr = [getAndroidID(), getMacAddr(), getTaid(), getOaid(), getImei()];
        }
        const deviceInfoPromise = Promise.all(promiseArr)
            .then((results) => {
            clearTimeout(exceptionHandler);
            return Promise.resolve({
                androidId: results[0],
                macAddr: results[1],
                taid: results[2] || '',
                oaid: results[3] || '',
                imei: results[4] || '',
            });
        })
            .catch(() => {
            clearTimeout(exceptionHandler);
            return Promise.resolve({});
        });
        return Promise.race([exceptionPromise, deviceInfoPromise]);
    }
    return Promise.resolve({});
};
exports.getAndroidDeviceInfo = getAndroidDeviceInfo;
const getLoginData = () => {
    var _b, _c;
    const getData = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.login) === null || _c === void 0 ? void 0 : _c.getAccountInfo;
    if (getData) {
        return new Promise((resolve) => {
            getData((data) => {
                resolve(data);
            });
        });
    }
    return Promise.resolve({});
};
exports.getLoginData = getLoginData;
const getQQBrowserVerCode = (count = 1) => strVersionToCode(getBrowserVersion(), count);
exports.getQQBrowserVerCode = getQQBrowserVerCode;
const getBrowserVersion = () => getQuaVal('PPVN');
exports.getBrowserVersion = getBrowserVersion;
const getQuaVal = (key) => {
    var _b, _c;
    const qua2 = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.qua2;
    if (qua2) {
        const queryObj = {};
        const quaArray = qua2.toUpperCase().split('&');
        quaArray.forEach((arr) => {
            const item = arr.split('=');
            if (item.length === 2) {
                const [a, b] = item;
                queryObj[a] = b;
            }
        });
        return queryObj[key];
    }
    return '';
};
const strVersionToCode = (qbVersion, count = 1) => {
    if (qbVersion) {
        const qbVerArr = String(qbVersion).split('.');
        switch (count) {
            case 1:
                if (qbVerArr === null || qbVerArr === void 0 ? void 0 : qbVerArr[0]) {
                    return parseInt(qbVerArr[0], 10);
                }
                break;
            case 2:
                if ((qbVerArr === null || qbVerArr === void 0 ? void 0 : qbVerArr[0]) && qbVerArr[1]) {
                    return parseInt(qbVerArr[0], 10) * 10 + (parseInt(qbVerArr[1], 10) % 10);
                }
                break;
            case 3:
                if ((qbVerArr === null || qbVerArr === void 0 ? void 0 : qbVerArr[0]) && qbVerArr[1] && qbVerArr[2]) {
                    const a = parseInt(qbVerArr[0], 10) * 100;
                    const b = (parseInt(qbVerArr[1], 10) % 10) * 10;
                    const c = parseInt(qbVerArr[2], 10) % 10;
                    return a + b + c;
                }
                break;
            default:
                return 0;
        }
    }
    return 0;
};
const getAndroidPkgInfo = (packageName) => {
    var _b, _c, _d, _e;
    const getApkInfo = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.app) === null || _c === void 0 ? void 0 : _c.getApkInfo;
    const platForm = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.env) === null || _e === void 0 ? void 0 : _e.platForm;
    return new Promise((resolve) => {
        if (platForm === 'ADR') {
            getApkInfo((info) => {
                try {
                    if (info) {
                        const apkObj = JSON.parse(JSON.parse(info));
                        resolve(apkObj);
                    }
                }
                catch (e) {
                    resolve(null);
                }
            }, packageName);
        }
        else {
            resolve(null);
        }
    });
};
const isAppInstalled = (packagename, scheme) => {
    var _b, _c, _d, _e;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    const isInstallApk = (_e = (_d = window === null || window === void 0 ? void 0 : window.browser) === null || _d === void 0 ? void 0 : _d.app) === null || _e === void 0 ? void 0 : _e.isInstallApk;
    const option = platForm === 'ADR' ? { packagename } : { apkKey: scheme };
    return new Promise((resolve) => {
        isInstallApk((ret) => {
            resolve(ret);
        }, option);
    });
};
let wxVersionName;
const getWxPkgVersion = () => {
    var _b, _c;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    const packagename = 'com.tencent.mm';
    if (wxVersionName) {
        return Promise.resolve(wxVersionName);
    }
    const isBaipai = isBaipaiBrowser();
    if (isBaipai) {
        return Promise.resolve('');
    }
    let exceptionHandler;
    const exceptionPromise = new Promise((resolve) => {
        exceptionHandler = setTimeout(() => {
            resolve('');
        }, 2000);
    });
    const wxPkgVersionPromise = isWxInstalled().then((isInstalled) => {
        if (isInstalled && platForm === 'ADR') {
            return getAndroidPkgInfo(packagename).then((pkgInfo) => {
                clearTimeout(exceptionHandler);
                return Promise.resolve(pkgInfo.versionname);
            });
        }
        if (isInstalled) {
            clearTimeout(exceptionHandler);
            return Promise.resolve('6.6.1');
        }
        clearTimeout(exceptionHandler);
        return Promise.resolve('');
    });
    return Promise.race([exceptionPromise, wxPkgVersionPromise]);
};
exports.getWxPkgVersion = getWxPkgVersion;
const isWxInstalled = () => {
    const packagename = 'com.tencent.mm';
    const scheme = 'weixin://';
    return isAppInstalled(packagename, scheme);
};
let qqVersionName;
const getQQPkgVersion = () => {
    var _b, _c;
    const platForm = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.env) === null || _c === void 0 ? void 0 : _c.platForm;
    const packagename = 'com.tencent.mobileqq';
    if (qqVersionName) {
        return Promise.resolve(qqVersionName);
    }
    const isBaipai = isBaipaiBrowser();
    if (isBaipai) {
        return Promise.resolve('');
    }
    let exceptionHandler;
    const exceptionPromise = new Promise((resolve) => {
        exceptionHandler = setTimeout(() => {
            resolve('');
        }, 2000);
    });
    const qqPkgVersionPromise = isQQInstalled().then((isInstalled) => {
        if (isInstalled && platForm === 'ADR') {
            return getAndroidPkgInfo(packagename).then((pkgInfo) => {
                clearTimeout(exceptionHandler);
                return Promise.resolve(pkgInfo.versionname);
            });
        }
        if (isInstalled) {
            clearTimeout(exceptionHandler);
            return Promise.resolve('');
        }
        clearTimeout(exceptionHandler);
        return Promise.resolve('');
    });
    return Promise.race([exceptionPromise, qqPkgVersionPromise]);
};
exports.getQQPkgVersion = getQQPkgVersion;
const isQQInstalled = () => {
    const packagename = 'com.tencent.mobileqq';
    const scheme = 'mqqapi://miniapp/open';
    return isAppInstalled(packagename, scheme);
};
const baipaiVerCode = 0;
const getBaipaiVerCode = () => {
    var _b, _c;
    const getApkInfo = (_c = (_b = window === null || window === void 0 ? void 0 : window.browser) === null || _b === void 0 ? void 0 : _b.app) === null || _c === void 0 ? void 0 : _c.getApkInfo;
    const packagename = 'com.android.browser';
    if (baipaiVerCode > 0) {
        return Promise.resolve(baipaiVerCode);
    }
    if (getApkInfo) {
        return new Promise((resolve) => {
            getApkInfo((info) => {
                try {
                    let newInfo;
                    newInfo = info.replace(/\\/g, '');
                    newInfo = info.substr(1);
                    newInfo = info.substr(0, info.length - 1);
                    if (newInfo) {
                        const apkObj = JSON.parse(newInfo);
                        if (apkObj === null || apkObj === void 0 ? void 0 : apkObj.versioncode) {
                            resolve(apkObj.versioncode);
                        }
                        else {
                            resolve(0);
                        }
                    }
                }
                catch (e) {
                    resolve(0);
                }
            }, packagename);
        });
    }
    return Promise.resolve(0);
};
const isBaipaiBrowser = () => getQuaVal('PB') === 'TMS';
const showToast = (msg = '') => {
    var _b, _c;
    if ((_c = (_b = window.browser) === null || _b === void 0 ? void 0 : _b.app) === null || _c === void 0 ? void 0 : _c.toast) {
        window.browser.app.toast(msg, 1);
    }
    else {
        console.error('toast msg:', msg);
    }
};
exports.showToast = showToast;
const formatDataNoSlice = (obj) => {
    const result = {};
    Object.keys(obj).forEach((key) => {
        result[formatKeyNoSlice(key)] = obj[key];
    });
    return result;
};
exports.formatDataNoSlice = formatDataNoSlice;
const formatKeyNoSlice = (key) => key.replace(/^(\w)/g, (_a, b) => b.toLowerCase());
const formatData = (obj) => {
    const result = {};
    Object.keys(obj).forEach((key) => {
        result[formatKey(key)] = obj[key];
    });
    return result;
};
exports.formatData = formatData;
const formatKey = (key) => key.slice(1).replace(/^(\w)/g, (_a, b) => b.toLowerCase());
const getConnetType = (n) => {
    let type = 'unknow';
    if (`${n}` === '1') {
        type = 'wifi';
    }
    else {
        type = `${n}g`;
    }
    return type;
};
exports.getConnetType = getConnetType;
const debounce = (fn, delay, immediate) => {
    let timer = null;
    return ((...args) => {
        timer && clearTimeout(timer);
        if (immediate) {
            const isCallNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, delay);
            isCallNow && fn(...args);
        }
        else {
            timer = setTimeout(() => {
                fn(...args);
            }, delay);
        }
    });
};
exports.debounce = debounce;
//# sourceMappingURL=tools.js.map